import { Card, Stack, Button, Heading, Text, Box } from '@chaser/components';
import { useField } from 'formik';
import styles from './SelectableCard.module.scss';

import React from 'react';

const SelectableCard = ({
  name,
  value,
  icon,
  title,
  description,
  gap = 'xlarge',
  type = 'radio',
  ...rest
}) => {
  const [field, meta] = useField({ name, value, type });

  return (
    <Card
      className={styles.styledCard}
      as="label"
      width="medium"
      appearance="secondary"
      intent={meta.touched && !!meta.error ? 'danger' : field.checked ? 'info' : 'neutral'}
      p="small"
      {...rest}
    >
      <Stack gap={gap}>
        <Stack gap="medium" alignItems="center" pt="small" pb="medium">
          {icon && (
            <Box color={field.checked ? 'Blue AA' : 'Mid Neutral 1'}>
              <svg width="72" height="72">
                <use href={`${icon}#icon`} x="0" y="0" fill="currentColor" />
              </svg>
            </Box>
          )}
          <Heading
            as="h2"
            fontSize="medium"
            fontWeight="bold"
            textAlign="center"
            color={field.checked ? 'Blue AA' : 'Dark Neutral 1'}
          >
            {title}
          </Heading>
          <Text textAlign="center" color={field.checked ? 'Blue' : 'Mid Neutral 1'}>
            {description}
          </Text>
        </Stack>
        <Button as="div" disabled={field.checked}>
          {field.checked ? 'Selected' : 'Select'}
        </Button>
        <input className={styles.visuallyHidden} type={type} {...field} />
      </Stack>
    </Card>
  );
};

export default SelectableCard;
